import HelperIcon from "components/HelperIcon/HelperIcon";
import ClientModal from "custom_modules/WorkOrderNew/CreateWorkOrder/ClientModal";
import { createNotification } from "modules/notificationManager";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useCallback } from "react";
import { useDebouncedCallback } from "use-debounce";



import crossIcon from "../../../assets/img/icons/cross_black.svg";
import Plus from "../../../assets/img/icons/plus.svg";
import reorder from "../../../assets/img/reorder.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ProjectDropdown from "../../../components/CommonFilter/ProjectDropdown";
import DotLoader from "../../../components/DropdownLoader/DropdownLoader";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import PricingPlan from "../../../components/PricingPlan";
import Select from "../../../components/ReactSelectDropdown";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import InfoTooltip from "../../../components/Tooltip/InfoTooltip";
import { ColoredButton, PrimaryBgButton, PrimaryButton, PrimaryWhiteBgButton, WhiteButton } from "../../../styledComponents/buttons";
import { CardTitle, ColoredText, CommonGrid, CommonText, Container, ContainerNew, InputField, InputLabel, InputWithLabelSection, PageTitle, RedStar, TableText } from "../../../styledComponents/common";
import { BillingQues, BillingTooltip, BillingTooltipText, Cross, CrossIcon, FormAlert, GeneralDetailsInputContainer } from "../../../styledComponents/createProject";
import { AddItem, AddItemContainer, CalculationContainer, CreateInvoiceItemContainer, CreateInvoiceSubTitle, ReorderSelectSection, SubmitButtonContainer, TaxTypeButton, ToggleButton, ToggleButtonRound } from "../../../styledComponents/invoice";
import { currenciesWithSymbols, currencySymbolMap } from "../../../utils/currencies";
import AddClientPopup from "../AddClientPopup";
import InvoiceLineItemSectionCreate from "../Components/InvoiceLineItemSectionCreate";
import VisitDateComponent from "../Components/VisitDateComponent";
import SendMailPopup from "../SendMailPopup";


const CreateInvoice = ({
  createInvoiceLoading,
  clearInvoiceLinkedProject,
  selectedOrganization,
  getClientShortList,
  getInvoiceNumber,
  clientShortList,
  createdClientId,
  createdInvoiceInfo,
  invoiceNumber,
  sendInvoiceEmailInfo,
  history,
  linkedProjectState,
  invoiceLinkProject,
  createInvoice,
  createClient,
  profileData,
  sendMailLoading,
  log,
  sendInvoiceEmail,
  isLoading,
  linkProjectLoading,
  createInvoiceUpdateSendLog,
  isInvoiceLimitFull,
  invoiceNumberAlreadyExists,
  jobList,
  getJobList,
  appOnboardingSteps,
  completeAppOnboardingStep,
  createdClientInfo,
}) => {
  const [selectClient, setSelectClient] = useState("");

  const [clientOptions, setClientOptions] = useState([]);

  const [invoiceNo, setInvoiceNo] = useState("");

  const [issuedDate, setIssuedDate] = useState(moment(new Date()));

  const [dueDate, setDueDate] = useState(null);

  const [poValue, setPoValue] = useState("");
  const [selectedJob, setSelectedJob] = useState(null);
  const [filteredJobListOptions, setFilteredJobListOptions] = useState([]);
  const [recurringJobList, setRecurringJobList] = useState([]);
  const [selectedVisitJobs, setSelectedVisitJobs] = useState([]);
  const [shouldLoadJobs, setShouldLoadJobs] = useState(false); // Controls when job list should be processed
  const [filteredJobList, setFilteredJobList] = useState([]);

  const [currency, setCurrency] = useState({
    label: "USD ($) - United States Dollar",
    value: "USD",
  });
  const orgTimeZone = selectedOrganization?.timezone;
  const orgType = selectedOrganization?.type || "operation";

  const [itemArray, setItemArray] = useState([]);

  const [descriptionState, setDescriptionState] = useState({
    index: -1,
    value: "",
  });

  const [quantityState, setQuantityState] = useState({
    index: -1,
    value: 0,
  });

  const [unitPriceState, setUnitPriceState] = useState({
    index: -1,
    value: 0,
  });

  const [focusedIndex, setFocusedIndex] = useState(-1);

  const [tax1, setTax1] = useState({
    percent: true,
    name: "",
    value: 0,
  });

  const [tax2, setTax2] = useState({
    percent: true,
    name: "",
    value: 0,
  });

  const [discount, setDiscount] = useState({
    percent: true,
    value: 0,
  });

  const itemTypeOptions = [
    { value: "service", label: "Service" },
    { value: "product", label: "Product" },
  ];

  const [totalCalc, setTotalCalc] = useState(0);
  const [grandTotalValue, setGrandTotalValue] = useState(0);

  const [saveErrors, setSaveErrors] = useState({});

  const [popupOpen, setPopupOpen] = useState(false);
  const [sendEmailOpen, setSendEmailOpen] = useState(false);
  const [toolTipActive, setToolTipActive] = useState(-1);
  const [sentState, setSentState] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const [linkedItemIndex, setLinkedItemIndex] = useState(null);
  const [pricingPopup, setPricingPopup] = useState(false);

  // only for the button loader
  const [isDraft, setIsDraft] = useState(true);

  const myRef = useRef(null);
  const selectRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();

  useEffect(() => {
    if (selectedOrganization?.id && clientOptions?.length > 0) {
      setTimeout(() => {
        if (selectRef.current) {
          selectRef.current.focus(); // Works in v5
        }
      }, 100);
    }
  }, [clientOptions, selectRef.current, selectedOrganization]);

  useEffect(() => {
    return () => {
      clearInvoiceLinkedProject();
    };
  }, []);

  useEffect(() => {
    // Reset all job and item-related state when customer changes
    setItemArray([]);
    setSelectedJob(null);
    setShouldLoadJobs(false); // Reset job loading flag
    setFilteredJobList([]);
    setFilteredJobListOptions([]);
    setRecurringJobList([]);
    setSelectedVisitJobs([]);
  }, [selectClient]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (
        selectedOrganization?.plan?.name === "Standard" ||
        selectedOrganization?.plan?.nick_name === "standard-free"
      ) {
        pricingPopupToggle();
      }
      if (
        selectedOrganization.configuration &&
        selectedOrganization.configuration.currency
      ) {
        setCurrency({
          label: `${selectedOrganization.configuration.currency} (${currencySymbolMap[selectedOrganization.configuration.currency]
            })`,
          value: selectedOrganization.configuration.currency,
        });
      }
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getClientShortList(payload);
      getInvoiceNumber(payload);
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (clientShortList?.length > 0) {
      let options = [];
      clientShortList
        .filter(item => item.is_active)
        .map(item => {
          // if (createdClientId === item.id) {
          //   setSelectClient({
          //     value: createdClientId,
          //     label: item.name,
          //   });
          // }

          options.push({
            value: item.id,
            label: item.name,
          });
        });
      setClientOptions(options);
    }
  }, [clientShortList]);

  useEffect(() => {
    totalCalculation();
  }, [itemArray]);

  useEffect(() => {
    if (createdClientId && selectedOrganization && selectedOrganization.id) {
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getClientShortList(payload);
    }
  }, [createdClientId]);

  useEffect(() => {
    if (createdInvoiceInfo?.id && isCreated) {
      if (createdInvoiceInfo.saveAndSend) {
        setSendEmailOpen(true);
      } else {
        history.push(`/user/invoice-preview?id=${createdInvoiceInfo.id}`);
      }
    }
  }, [createdInvoiceInfo]);

  useEffect(() => {
    if (invoiceNumber && invoiceNumber.invoice_number) {
      setInvoiceNo(invoiceNumber.invoice_number);
    }
  }, [invoiceNumber]);

  useEffect(() => {
    if (sendInvoiceEmailInfo && sendInvoiceEmailInfo.log_id && sentState && selectedOrganization?.id) {
      const step = appOnboardingSteps?.find(s => s.name === "create_invoice" || s.id === "create_invoice");
      if (step && step.status !== "completed") {
        completeAppOnboardingStep(selectedOrganization.id, "create_invoice");
      }
      history.push(`/user/invoice-preview?id=${createdInvoiceInfo.id}`);
    }
  }, [sendInvoiceEmailInfo, appOnboardingSteps, selectedOrganization?.id, completeAppOnboardingStep]);

  useEffect(() => {
    let newArr = [...itemArray];
    if (
      linkedProjectState &&
      linkedItemIndex !== null &&
      linkedProjectState.linked_project_id ==
      itemArray[linkedItemIndex].linkedProject.value
    ) {
      newArr[linkedItemIndex].unitPrice = parseFloat(
        linkedProjectState.unit_price,
      ).toFixed(2);
      setItemArray(newArr);
    } else if (!linkedProjectState && linkedItemIndex !== null) {
      newArr[linkedItemIndex].unitPrice = 0;
      setItemArray(newArr);
    }
  }, [linkedProjectState, linkedItemIndex]);

  useEffect(() => {
    if (isInvoiceLimitFull && isCreated) {
      setPricingPopup(true);
    }
  }, [isInvoiceLimitFull]);
  useEffect(() => {
    if (invoiceNumberAlreadyExists) {
      document.getElementById("invoiceNumber").focus();
    }
  }, [invoiceNumberAlreadyExists]);

  const onClientChange = e => {
    let errors = { ...saveErrors };
    delete errors["client"];
    setSaveErrors(errors);
    setSelectClient(e);
  };

  const onInvoiceNumberChange = e => {
    setInvoiceNo(e.target.value);
  };

  const onIssuedDateChange = date => {
    setIssuedDate(date);
  };

  const onDueDateChange = date => {
    setDueDate(date);
  };

  const onPoValueChange = e => {
    setPoValue(e.target.value);
  };

  const onCurrencyChange = e => {
    setCurrency(e);
  };

  const onJobChange = job => {
    setSelectedJob(job);
    if (job && job.code) {
      filterRecurringJobs(job.code);
    }

    // Check if the selected job is recurring and filter accordingly
    if (job?.value && jobList.length > 0) {
      const selectedJobData = jobList.find(j => j.id === job.value);

      if (job.recurring) {
        // For recurring jobs, show visit date selection
        setSelectedVisitJobs([]); // Clear any previously selected visits
      } else {
        // For single (non-recurring) jobs, automatically add to selectedVisitJobs
        if (selectedJobData) {
          setSelectedVisitJobs([selectedJobData]);
        }
        setRecurringJobList([]); // Clear recurring job list
      }
    } else {
      // Clear selections when no job is selected
      setRecurringJobList([]);
      setSelectedVisitJobs([]);
    }
  };

  // const onItemTypeChange = (e, index) => {
  //   let newArr = [...itemArray];
  //   newArr[index].type = e;
  //   setItemArray(newArr);
  // };

  // const onItemDescFocus = index => {
  //   setSaveErrors({});
  //   setDescriptionState({ index: index, value: itemArray[index].description });
  // };

  // const onItemDescChange = (e, index) => {
  //   let errors = { ...saveErrors };
  //   delete errors[`itemDescription_${index}`];
  //   setSaveErrors(errors);
  //   setDescriptionState({
  //     ...descriptionState,
  //     value: e.target.value,
  //   });
  // };

  // const onItemDescBlur = index => {
  //   let newArr = [...itemArray];
  //   newArr[index].description = descriptionState.value;
  //   setItemArray(newArr);
  //   setDescriptionState({
  //     active: -1,
  //     value: "",
  //   });
  // };

  // const onItemQuantityChange = (e, index) => {
  //   let errors = { ...saveErrors };
  //   delete errors[`itemQuantity_${index}`];
  //   setSaveErrors(errors);

  //   let newArr = [...itemArray];
  //   newArr[index].quantity = e.target.value;
  //   setItemArray(newArr);
  // };

  // const onItemUnitPriceChange = (e, index) => {
  //   let errors = { ...saveErrors };
  //   delete errors[`itemUnitPrice_${index}`];
  //   setSaveErrors(errors);

  //   let newArr = [...itemArray];
  //   newArr[index].unitPrice = e.target.value;
  //   setItemArray(newArr);
  // };

  // const onItemTax1Change = index => {
  //   let newArr = [...itemArray];
  //   newArr[index].tax1 = !newArr[index].tax1;
  //   setItemArray(newArr);
  //   grandTotalCalculation();
  // };

  // const onItemTax2Change = index => {
  //   let newArr = [...itemArray];
  //   newArr[index].tax2 = !newArr[index].tax2;
  //   setItemArray(newArr);
  //   grandTotalCalculation();
  // };

  // const onItemLinkedProjectChange = (e, index) => {
  //   let newArr = [...itemArray];
  //   newArr[index].linkedProject = e;
  //   newArr[index].description = e.label;
  //   newArr[index].quantity = 1;
  //   setItemArray(newArr);
  //   setLinkedItemIndex(index);

  //   if (selectedOrganization && selectedOrganization.id) {
  //     invoiceLinkProject({
  //       organization_id: selectedOrganization.id,
  //       linked_project_id: e.value,
  //     });
  //   }
  // };

  // const addItemToarray = () => {
  //   let newArray = [...itemArray];
  //   let newItem = {
  //     type: { value: "service", label: "Service" },
  //     description: "",
  //     quantity: 0,
  //     unitPrice: 0,
  //     tax1: true,
  //     tax2: true,
  //     linkedProject: "",
  //   };
  //   newArray.push(newItem);
  //   setItemArray(newArray);
  //   setSaveErrors({});
  // };

  // const handleDeleteItem = index => {
  //   let newArray = [...itemArray];
  //   newArray.splice(index, 1);
  //   setItemArray(newArray);
  // };

  // const onTax1NameChange = e => {
  //   setTax1({ ...tax1, name: e.target.value });
  // };

  // const onTax1ValueChange = e => {
  //   let errors = { ...saveErrors };
  //   delete errors[`tax1Value`];
  //   setSaveErrors(errors);

  //   setTax1({ ...tax1, value: e.target.value });
  // };

  // const toggleTax1CalcType = value => {
  //   setTax1({
  //     ...tax1,
  //     percent: value,
  //   });
  // };

  // const onTax2NameChange = e => {
  //   setTax2({ ...tax2, name: e.target.value });
  // };

  // const onTax2ValueChange = e => {
  //   let errors = { ...saveErrors };
  //   delete errors[`tax2Value`];
  //   setSaveErrors(errors);

  //   setTax2({ ...tax2, value: e.target.value });
  // };

  // const toggleTax2CalcType = value => {
  //   setTax2({
  //     ...tax2,
  //     percent: value,
  //   });
  // };

  // const onDiscountValueChange = e => {
  //   let errors = { ...saveErrors };
  //   delete errors[`discountValue`];
  //   delete errors[`discountFixed`];
  //   setSaveErrors(errors);

  //   setDiscount({ ...discount, value: e.target.value });
  // };

  // const toggleDiscountCalcType = value => {
  //   setDiscount({
  //     ...discount,
  //     percent: value,
  //   });
  // };

  const totalCalculation = () => {
    if (itemArray && itemArray.length) {
      let total = 0;
      itemArray.map(item => {
        total += item.quantity * item.unitPrice;
      });
      setTotalCalc(total.toFixed(2));
    }
  };

  // Fetch job list when client is selected
  useEffect(() => {
    if (selectClient?.value && selectedOrganization?.id) {
      const payload = {
        client_id: selectClient.value,
        organization_id: selectedOrganization.id,
        start_date: moment().subtract(15, "days").format("YYYY-MM-DD"),
        end_date: moment().add(15, "days").format("YYYY-MM-DD"),
      };
      getJobList(payload);
      setShouldLoadJobs(true); // Enable job processing when fetching for a customer
    } else {
      setShouldLoadJobs(false); // Disable job processing when no customer
    }
  }, [selectClient, selectedOrganization]);

  // Filter job list: single jobs + one instance of each recurring job
  useEffect(() => {
    // Only process job list when a customer is selected
    if (!shouldLoadJobs) {
      setFilteredJobList([]);
      setFilteredJobListOptions([]);
      return;
    }

    if (jobList?.length > 0) {
      const recurringJobCodes = new Set();
      const filtered = [];

      jobList.forEach(job => {
        if (job.code && job.recurring) {
          // For recurring jobs, only add the first occurrence of each code
          if (!recurringJobCodes.has(job.code)) {
            recurringJobCodes.add(job.code, true);
            filtered.push(job);
          }
        } else {
          // Add all single jobs
          filtered.push(job);
        }
      });

      setFilteredJobList(filtered);

      // Create dropdown options with only unique recurring jobs
      const jobOptions = filtered.map(job => ({
        value: job.id,
        label: job.name,
        code: job.code || null,
        recurring: job.recurring || false,
      }));
      setFilteredJobListOptions(jobOptions);
    } else {
      setFilteredJobList([]);
      setFilteredJobListOptions([]);
    }
  }, [jobList, shouldLoadJobs]);

  // Filter recurring jobs when a specific recurring job is selected
  const filterRecurringJobs = selectedJobCode => {
    if (!jobList || jobList.length === 0 || !selectedJobCode) {
      setRecurringJobList([]);
      return;
    }

    const tz = selectedOrganization?.timezone || moment.tz.guess();
    const today = moment().tz(tz).format("YYYY-MM-DD");

    const recurringJobs = jobList.filter(
      job => job.code === selectedJobCode && job.recurring,
    );

    const toMoment = time => (time ? moment(time + "Z").tz(tz) : null);

    // Sort by localized start_time (oldest first)
    const sortedJobs = recurringJobs.sort((a, b) => {
      const ma = toMoment(a.start_time);
      const mb = toMoment(b.start_time);
      if (!ma && !mb) return 0;
      if (!ma) return 1;
      if (!mb) return -1;
      return ma.diff(mb);
    });

    const todayJobs = sortedJobs.filter(job => {
      const m = toMoment(job.start_time);
      return m && m.isSame(today, "day");
    });

    const pastJobs = sortedJobs.filter(job => {
      const m = toMoment(job.start_time);
      return m && m.isBefore(today, "day");
    });

    const futureJobs = sortedJobs.filter(job => {
      const m = toMoment(job.start_time);
      return m && m.isAfter(today, "day");
    });

    // Pick last 2 past, 1 today (if any), first 2 future
    const lastTwo = pastJobs.slice(-2);
    const todayJob = todayJobs.length > 0 ? [todayJobs[0]] : [];
    const upcomingTwo = futureJobs.slice(0, 2);

    const filtered = [...lastTwo, ...todayJob, ...upcomingTwo];

    setRecurringJobList(filtered);
  };

  const handleVisitDateSelect = (job, index) => {
    setSelectedVisitJobs(prev => {
      const exists = prev && prev.find(j => j && j.id === job.id);
      if (exists) {
        // remove deselected job
        return prev.filter(j => j && j.id !== job.id);
      }
      // add newly selected job
      return [...(prev || []), job];
    });
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };
  const sendEmailToggle = () => {
    setSendEmailOpen(!sendEmailOpen);
  };

  const onSend = () => {
    setSentState(true);
  };

  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  const checkError = () => {
    let formIsValid = true;
    let saveErrors = {};
    if (selectClient === "") {
      saveErrors["client"] = "Customer can not be empty";
      formIsValid = false;
      executeScroll();
    }

    // if (!selectedJob) {
    //   saveErrors["job"] = "Job is required";
    //   formIsValid = false;
    //   executeScroll();
    // }

    // Check that issued date is not before today
    // if (issuedDate) {
    //   const today = moment().startOf('day');
    //   if (issuedDate.isBefore(today, 'day')) {
    //     saveErrors["issuedDate"] = "Issued date cannot be before today";
    //     formIsValid = false;
    //   }
    // }

    // Due Date should be after Issued Date and not before today
    if (dueDate && issuedDate && dueDate.isBefore(issuedDate, 'day')) {
      saveErrors['dueDate'] = 'Due date should be after issued date';
      formIsValid = false;
      executeScroll();
    } 
    // else if (dueDate) {
    //   const today = moment().startOf('day');
    //   if (dueDate.isBefore(today, 'day')) {
    //     saveErrors['dueDate'] = 'Due date cannot be before today';
    //     formIsValid = false;
    //   }
    // }

    const calculateTaxDiscountLocal = (object, cost) => {
      if (object.percent) {
        return (object.value * cost) / 100;
      } else if (object.value) {
        return object.value;
      } else {
        return 0;
      }
    };

    let localTotalCalc = 0;

    if (itemArray && itemArray.length > 0) {
      let hasNegativePrice = false;
      itemArray.forEach((item, index) => {
        if (item.description && item.description.length > 512) {
          saveErrors[`itemDescription_${index}`] =
            "Item Description can have maximum 512 characters";
          formIsValid = false;
        }
        if (parseFloat(item.unitPrice) < 0) {
          saveErrors[`itemUnitPrice_${index}`] =
            "Item unit-price can't be negative.";
          formIsValid = false;
          hasNegativePrice = true;
        }

        if (parseFloat(item.quantity) > 0) {
          localTotalCalc +=
            parseFloat(item.quantity) * parseFloat(item.unitPrice);
        }
      });
      if (hasNegativePrice)
        createNotification("error", "Item unit price can't be negative.");
    } else {
      saveErrors["noItem"] = "You have to add at least one item";
      createNotification("error", saveErrors["noItem"]);
      formIsValid = false;
    }

    if (tax1 && parseFloat(tax1.value) < 0) {
      saveErrors["tax1Value"] = "Tax 1 value can't be negative.";
      formIsValid = false;
    }
    if (tax2 && parseFloat(tax2.value) < 0) {
      saveErrors["tax2Value"] = "Tax 2 value can't be negative.";
      formIsValid = false;
    }

    if (discount && discount.percent && parseFloat(discount.value) > 100) {
      saveErrors["discountValue"] = "Discount can't be greater than 100%.";
      formIsValid = false;
    } else if (
      discount &&
      !discount.percent &&
      parseFloat(discount.value) > localTotalCalc
    ) {
      saveErrors["discountFixed"] =
        "Discount can't be greater than total amount";
      formIsValid = false;
    }

    // Local Grand Total Calculation
    let totalTax = 0;
    itemArray.forEach(item => {
      if (parseFloat(item.quantity) > 0) {
        let itemCost = parseFloat(item.quantity) * parseFloat(item.unitPrice);
        if (item.tax1)
          totalTax += parseFloat(calculateTaxDiscountLocal(tax1, itemCost));
        if (item.tax2)
          totalTax += parseFloat(calculateTaxDiscountLocal(tax2, itemCost));
      }
    });

    // let localGrandTotal =
    //   localTotalCalc +
    //   totalTax -
    //   parseFloat(calculateTaxDiscountLocal(discount, localTotalCalc));

    if (grandTotalValue <= 0 && formIsValid) {
      createNotification(
        "error",
        "Invoice total amount can't be zero or less.",
      );
      formIsValid = false;
    }

    setSaveErrors(saveErrors);
    return formIsValid;
  };


  const handleSave = useDebouncedCallback(saveAndSend => {
    if (checkError()) {
      if (selectedOrganization && selectedOrganization.id) {
        let newItems = [];
        console.log("🚀 ~ file: CreateInvoice.jsx:678 ~ handleSave ~ itemArray:", itemArray);
        console.log("itemArray", itemArray);

        itemArray?.length > 0 &&
          itemArray.map((item, index) => {
            if (item.quantity > 0) {
              let newItem = {};
              newItem.type = item.item_type;
              newItem.name = item.name;
              newItem.description = item.description;
              newItem.unit_price = item.unitPrice || item.unit_price;
              newItem.quantity = item.quantity;
              newItem.tax1 = item.tax1;
              newItem.tax2 = item.tax2;
              newItems.push(newItem);
            }
          });

        let payload = {
          organization_id: selectedOrganization.id,
          client_id: selectClient.value,
          job: selectedJob ? selectedJob.value : null,
          invoice_number:
            invoiceNo === ""
              ? `${selectedOrganization.name.substring(
                0,
                selectedOrganization.name.indexOf(" "),
              )}_${Math.ceil(Math.random() * 10000)}`
              : invoiceNo,

          issued_date: issuedDate.format("YYYY-MM-DD"),
          due_date: dueDate !== null ? dueDate.format("YYYY-MM-DD") : dueDate,
          po_number: poValue === "" ? null : poValue,
          currency: (currency && currency.value) || "USD",
          tax1: {
            type: tax1.percent ? `percent` : `fixed`,
            name: tax1.name === "" ? `tax 1` : tax1.name,
            [tax1.percent ? `percent_amount` : `fixed_amount`]: tax1.value || 0,
          },
          tax2: {
            type: tax2.percent ? `percent` : `fixed`,
            name: tax2.name === "" ? `tax 2` : tax2.name,
            [tax2.percent ? `percent_amount` : `fixed_amount`]: tax2.value || 0,
          },
          discount: {
            type: discount.percent ? `percent` : `fixed`,
            [discount.percent ? `percent_amount` : `fixed_amount`]:
              discount.value || 0,
          },
          items: newItems,
          saveAndSend,
        };
        createInvoice(payload);
        setIsCreated(true);
        if (saveAndSend) {
          setIsDraft(false);
        }
      }
    }
    // navigate("/user/invoice-preview");
  }, 500);

  const cancelFunction = () => {
    history.push("/user/invoices");
  };

  return (
    <div className="content">
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText="You have reached the limit of creating invoices."
        popupTitle="Upgrade to Elite to create unlimited invoices"
        history={history}
        backRoute="/user/dashboard"
        onlyElite
      />
      {/* <PageTitle>Invoices</PageTitle> */}
      <div
        style={{
          display: `grid`,
          gridTemplateColumns: `auto`,
          justifyContent: `start`,
          marginTop: "12px",
        }}
      >
        <BackButtonComponent
          onClick={() => history.push("/user/invoices")}
          subTitle="Back to all invoices"
        />
      </div>
      {/* <CreateInvoiceSubTitle>
        Detail information of your Invoice
      </CreateInvoiceSubTitle> */}

      {selectedOrganization && selectedOrganization.id && (
        <ClientModal
          isOpen={popupOpen}
          toggle={popupToggle}
          selectedOrganization={selectedOrganization}
          createClient={createClient}
          createdClientId={createdClientId}
          createdClientInfo={createdClientInfo}
          setSelectedClient={setSelectClient}
          orgType={selectedOrganization?.type}
        />
      )}

      {selectedOrganization &&
        selectedOrganization.id &&
        createdInvoiceInfo &&
        createdInvoiceInfo.id &&
        profileData && (
          <SendMailPopup
            isOpen={sendEmailOpen}
            isLoading={sendMailLoading}
            toggle={sendEmailToggle}
            organization_id={selectedOrganization.id}
            organization_name={selectedOrganization.name}
            invoice_id={createdInvoiceInfo.id}
            senderName={profileData.first_name}
            invoiceNumber={createdInvoiceInfo.invoice_number}
            issuedDate={createdInvoiceInfo.issued_date}
            dueDate={createdInvoiceInfo.due_date}
            email={createdInvoiceInfo.client.email}
            log={log}
            createInvoiceUpdateSendLog={createInvoiceUpdateSendLog}
            sendInvoiceEmail={sendInvoiceEmail}
            onSend={onSend}
            history={history}
            createInvoice
          />
        )}

      <ContainerNew marginTop="16px" style={{ overflowX: 'auto' }} ref={myRef}>
        <PageTitle>Create Invoice</PageTitle>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            {/* <CommonText margin="10px 30px 15px">
              {selectedOrganization &&
                selectedOrganization.id &&
                selectedOrganization.name}
            </CommonText> */}
            <GeneralDetailsInputContainer style={{ minWidth: '1200px' }} disableResponsiveness={true}>
              <InputWithLabelSection alignContent="flex-start">
                <CommonGrid disableResponsive>
                  <InputLabel>
                    Customer <RedStar>*</RedStar>
                  </InputLabel>
                  <AddItem
                    columns="18px auto"
                    gap="5px"
                    onClick={() => popupToggle()}
                  >
                    <img src={Plus} alt="plus" />
                    <ColoredText
                      fontSize="14px"
                      primary
                      hover
                      borderRadius="32px"
                    >
                      Add Customer
                    </ColoredText>
                  </AddItem>
                </CommonGrid>
                <Select
                  key={`select-${clientOptions?.length}-${selectedOrganization?.id}`}
                  isSearchable
                  // inputRef={input => console.log("InputRef:", input)}
                  // ref={selectRef}
                  value={selectClient}
                  options={clientOptions}
                  placeholder="Select customer..."
                  onChange={e => {
                    onClientChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["client"],
                  })}
                />
                {saveErrors && saveErrors["client"] && (
                  <FormAlert>{saveErrors["client"]}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection alignContent="flex-start">
                <CommonGrid disableResponsive justifyContent="start" gap="4px">
                  <InputLabel margin="auto 0 0 0">Invoice Number</InputLabel>
                  <HelperIcon text="The invoice number is a unique number. You can customize this as you need." />
                </CommonGrid>
                <InputField
                  type="text"
                  placeholder="Type invoice number"
                  value={invoiceNo}
                  id="invoiceNumber"
                  onChange={e => onInvoiceNumberChange(e)}
                />
              </InputWithLabelSection>
              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>
                  Issued Date <RedStar>*</RedStar>
                </InputLabel>
                <DatePicker
                  id="createIssuedDate"
                  width="100%"
                  date={issuedDate}
                  onDateChange={onIssuedDateChange}
                  placeholder={"Select issued date"}
                  allowPreviousDates
                />
              </InputWithLabelSection>
              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>
                  Jobs <RedStar>*</RedStar>
                </InputLabel>
                <Select
                  isSearchable
                  value={selectedJob}
                  options={filteredJobListOptions}
                  placeholder="Select Job..."
                  onChange={e => {
                    onJobChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["job"],
                  })}
                />
                {saveErrors && saveErrors["job"] && (
                  <FormAlert>{saveErrors["job"]}</FormAlert>
                )}
              </InputWithLabelSection>

              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>Currency</InputLabel>
                <Select
                  isSearchable
                  value={currency}
                  options={currenciesWithSymbols}
                  placeholder="Select Currency..."
                  onChange={e => {
                    onCurrencyChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["currency"],
                  })}
                />
                {saveErrors && saveErrors["currency"] && (
                  <FormAlert>{saveErrors["currency"]}</FormAlert>
                )}
              </InputWithLabelSection>
              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>Due Date</InputLabel>
                <DatePicker
                  id="createDueDate"
                  width="100%"
                  date={dueDate}
                  onDateChange={onDueDateChange}
                  placeholder={"Select due date"}
                  allowPreviousDates
                  error={saveErrors && saveErrors['dueDate']}
                />
                {saveErrors && saveErrors['dueDate'] && (
                  <FormAlert>{saveErrors['dueDate']}</FormAlert>
                )}
              </InputWithLabelSection>
            </GeneralDetailsInputContainer>
            {recurringJobList?.length > 0 && (
              <InputWithLabelSection>
                <InputLabel>Visit Date</InputLabel>
                <CommonGrid disableResponsive columns="repeat(8, 1fr)" gap="10px">
                  {recurringJobList.map((job, index) => (
                    <VisitDateComponent
                      job={job}
                      key={index}
                      index={index}
                      visitDateSelect={handleVisitDateSelect}
                    />
                  ))}
                </CommonGrid>
              </InputWithLabelSection>
            )}
            <InvoiceLineItemSectionCreate
              setLineItems={setItemArray}
              currency={currency?.value}
              lineItems={itemArray}
              selectedVisitJobs={selectedVisitJobs}
              selectedJob={selectedJob}
              setTaxDiscount={(taxData) => {
                setTax1(taxData.tax1);
                setTax2(taxData.tax2);
                setDiscount(taxData.discount);
              }}
              setGrandTotal={setGrandTotalValue}
            />

            <CommonGrid
              margin="20px 0 40px 0"
              gap="16px"
              columns="auto auto"
              justifyContent="flex-start"
              disableResponsive
            >
              <PrimaryWhiteBgButton
                // type="grayMedium"
                // padding={createInvoiceLoading && isDraft && "0 30px"}
                onClick={() => handleSave(false)}
                disabled={createInvoiceLoading}
              >
                {createInvoiceLoading && isDraft ? (
                  <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                ) : (
                  "Save As Draft"
                )}
              </PrimaryWhiteBgButton>
              <PrimaryBgButton
                padding={createInvoiceLoading && !isDraft && "0 30px"}
                onClick={() => handleSave(true)}
                disabled={createInvoiceLoading}
              >
                {createInvoiceLoading && !isDraft ? (
                  <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                ) : (
                  "Save & Send"
                )}
              </PrimaryBgButton>
            </CommonGrid>
          </>
        )}
      </ContainerNew>
    </div>
  );
};

export default CreateInvoice;